import FileUploadButton from 'components/common/fileUploadButton'
import { usePageAccess } from 'hooks'
import { uploadFileOos } from 'utils/api/smartOosApi'

type Props = {
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>
}

const SmartOosFileUpload = ({ setRefetch }: Props) => {
  const { isEditor } = usePageAccess()
  return (
    <div className="mb-3 flex flex-wrap items-start justify-between">
      <div className="title">Smart OOS </div>
      {isEditor && (
        <div className="flex gap-3">
          <FileUploadButton
            uploadApiFunction={uploadFileOos}
            uploadButtonText="CSV File"
            setRefetch={setRefetch}
          />
        </div>
      )}
    </div>
  )
}

export default SmartOosFileUpload
